import OnboardingLayoutContainer from "./OnboardingLayoutContainer";
import OnboardingLayoutStore from "./OnboardingLayoutStore";

export default OnboardingLayoutStore(OnboardingLayoutContainer);
